/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_revcomp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is the sequence of the opposite DNA strand read 5′→3′. You complement each base (A↔T, G↔C) and then reverse the order.`)
};

const es_revcomp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es la secuencia de la hebra opuesta de ADN leída en dirección 5′→3′. Se complementa cada base (A↔T, G↔C) y luego se invierte el orden.`)
};

const de_revcomp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ist die Sequenz des gegenüberliegenden DNA-Strangs, gelesen 5′→3′. Sie komplementieren jede Base (A↔T, G↔C) und kehren dann die Reihenfolge um.`)
};

const nl_revcomp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het is de sequentie van de tegenoverliggende DNA-streng, gelezen 5′→3′. Je complementeert elke base (A↔T, G↔C) en keert daarna de volgorde om.`)
};

const fr_revcomp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est la séquence du brin d'ADN opposé lue 5′→3′. Vous complémentez chaque base (A↔T, G↔C) puis inversez l'ordre.`)
};

const it_revcomp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È la sequenza del filamento di DNA opposto letta 5′→3′. Si complementa ogni base (A↔T, G↔C) e poi si inverte l'ordine.`)
};

const pt_br2_revcomp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É a sequência da fita de DNA oposta lida na direção 5′→3′. Você complementa cada base (A↔T, G↔C) e depois inverte a ordem.`)
};

const pt_revcomp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É a sequência da cadeia de ADN oposta lida 5′→3′. Complementa-se cada base (A↔T, G↔C) e depois inverte-se a ordem.`)
};

const ja_revcomp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反対側のDNA鎖を5′→3′方向で読んだ配列です。各塩基を相補化 (A↔T, G↔C) してから順序を逆にします。`)
};

const zh_revcomp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它是对侧 DNA 链按 5′→3′ 方向读取的序列。先将每个碱基互补（A↔T，G↔C），再颠倒顺序。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const revcomp_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.revcomp_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("revcomp_faq_a1", locale)
	if (locale === "en") return en_revcomp_faq_a1(inputs)
	if (locale === "es") return es_revcomp_faq_a1(inputs)
	if (locale === "de") return de_revcomp_faq_a1(inputs)
	if (locale === "nl") return nl_revcomp_faq_a1(inputs)
	if (locale === "fr") return fr_revcomp_faq_a1(inputs)
	if (locale === "it") return it_revcomp_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_revcomp_faq_a1(inputs)
	if (locale === "pt") return pt_revcomp_faq_a1(inputs)
	if (locale === "ja") return ja_revcomp_faq_a1(inputs)
	return zh_revcomp_faq_a1(inputs)
};